import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

export default function LoadingScreen() {
    return <ClipLoader color="#fff" size={13} />;
}
